/**
 * 処理後物マスタ
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/after_disposal_items`

const after_disposal_item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit }, { after_type }) {
      return new Promise((resolve) => {
        const params = { after_type: after_type }
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, params).then(data => {
          resolve(data)
        })
      })
    }
  },
  mutations: {},
}

export default after_disposal_item

